import React from "react";
import { SettingsPageLayout as Layout } from "Containers/Settings/SettingsHub/SettingsPageLayout";
import { lazyLoader } from "Service/loader";
const UserDetail = lazyLoader(
  () => import("Containers/User/UserDetail/UserDetail")
);

export const UserDetailsPage = () => {
  return (
    <Layout>
      <UserDetail />
    </Layout>
  );
};
